import {
  closestCenter,
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import { API_CALLS } from "../../../../API/api_calls";
import { actions, useAppDispatch, useAppSelector } from "../../../../redux";
import { SortableItem } from "./SortableItem";

const ArticleContent = () => {
  const dispatch = useAppDispatch();
  const { body_content, post_id } = useAppSelector(
    (state) => state.article.draftArticle
  );

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const onDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = body_content.findIndex(
        (content) => content.id === Number(active.id)
      );
      const newIndex = body_content.findIndex(
        (content) => content.id === Number(over?.id)
      );
      const newBodyContent = arrayMove(body_content, oldIndex, newIndex);
      API_CALLS.ARTICLE.reorderArticleEntries({
        post_id,
        data: {
          orders: newBodyContent.map((content, index) => ({
            new_order: index,
            post_article_id: content.id,
          })),
        },
      });
      dispatch(actions.article.setBodyContentOrder(newBodyContent));
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
    >
      <SortableContext
        items={body_content}
        strategy={verticalListSortingStrategy}
      >
        {body_content.map((content) => (
          <SortableItem key={content.id} id={content.id} />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default ArticleContent;
